<template>

    <div class="px-6 py-4 bg-minplan-beige -mb-4">
        <page-title :title="$t('projects.leadChange')"></page-title>
    </div>

    <jet-form-section @submitted="updateContact()">

        <template #form>
            <!-- Card General Project Information -->
            <form-card :title="$t('projects.lead')" :description="$t('projects.leadDescription')">
                <div class="col-span-6">
                    <label for="company" class="block text-sm font-medium text-gray-700">{{
                            $t("contact.company")
                        }} <RequiredMark /></label>
                    <input type="text" name="company" id="company" v-model="form.updateContact.company"
                           class="mt-1 focus:ring-minplan-blue focus:border© block w-full shadow-sm sm:text-sm border-gray-300" />
                    <jet-input-error :message="form.errors['updateContact.company']" class="mt-2" />
                </div>

                <div class="col-span-6 sm:col-span-3 lg:col-span-3">
                    <label for="firstname" class="block text-sm font-medium text-gray-700">{{
                            $t("contact.firstname")
                        }} <RequiredMark /></label>
                    <input type="text" name="firstname" id="firstname" v-model="form.updateContact.firstname"
                           class="mt-1 focus:ring-minplan-blue focus:border-minplan-blue block w-full shadow-sm sm:text-sm border-gray-300" />
                    <jet-input-error :message="form.errors['updateContact.firstname']" class="mt-2" />
                </div>

                <div class="col-span-6 sm:col-span-3 lg:col-span-3">
                    <label for="lastname" class="block text-sm font-medium text-gray-700">{{
                            $t("contact.lastname")
                        }} <RequiredMark /></label>
                    <input type="text" name="lastname" id="lastname" v-model="form.updateContact.lastname"
                           class="mt-1 focus:ring-minplan-blue focus:border-minplan-blue block w-full shadow-sm sm:text-sm border-gray-300" />
                    <jet-input-error :message="form.errors['updateContact.lastname']" class="mt-2" />
                </div>

                <div class="col-span-6">
                    <label for="email" class="block text-sm font-medium text-gray-700">{{ $t("contact.email") }} <RequiredMark /></label>
                    <input type="text" name="email" id="email" v-model="form.updateContact.email"
                           class="mt-1 focus:ring-minplan-blue focus:border-minplan-blue block w-full shadow-sm sm:text-sm border-gray-300" />
                    <jet-input-error :message="form.errors['updateContact.email']" class="mt-2" />
                </div>


                <div class="col-span-6">
                    <label for="phone" class="block text-sm font-medium text-gray-700">{{
                            $t("contact.mobile")
                        }} <RequiredMark /></label>
                    <input type="text" name="phone" id="phone" v-model="form.updateContact.mobile"
                           :maxlength="$page.props.branding.mobile_number_max_digit || 12"
                           @input="form.updateContact.mobile = form.updateContact.mobile.replace(/[^0-9]/g, '').slice(0, $page.props.branding.mobile_number_max_digit || 12)"
                           class="mt-1 focus:ring-minplan-blue focus:border-minplan-blue block w-full shadow-sm sm:text-sm border-gray-300" />
                    <jet-input-error :message="form.errors['updateContact.mobile']" class="mt-2" />
                </div>
            </form-card>

        </template>

        <template #actions>
            <div class="flex justify-end my-4 mx-6">

                <button @click="cancel" type="button" class="inline-block uppercase font-semibold text-xs tracking-widest">{{ $t('actions.cancel') }}</button>

                <primary-button :class="{ 'opacity-25': form.processing }" :disabled="form.processing" class="ml-3 ">
                    {{ $t("actions.save") }}
                </primary-button>

            </div>
        </template>

    </jet-form-section>

</template>


<script>
import { defineComponent } from "vue";
import MainLayout from "@/Layouts/MainLayout";
import PrimaryButton from "@/Jetstream/PrimaryButton";
import JetSecondaryButton from "@/Jetstream/SecondaryButton";
import JetFormSection from "@/Jetstream/FormSection";
import JetInput from "@/Jetstream/Input";
import JetInputError from "@/Jetstream/InputError";
import JetLabel from "@/Jetstream/Label";
import FormCard from "@/Shared/Components/FormCard";
import PageTitle from "@/Shared/Components/PageTitle";
import RequiredMark from "@/Shared/Components/RequiredMark";
import { useForm } from "@inertiajs/inertia-vue3";

export default defineComponent({
    props: ["project"],
    inheritAttrs: false,
    emits: ["closeModal"],
    layout: MainLayout,
    components: {
        PageTitle,
        FormCard,
        PrimaryButton,
        JetFormSection,
        JetInput,
        JetInputError,
        JetLabel,
        JetSecondaryButton,
        RequiredMark
    },
    data() {
        return {
            form: useForm({
                updateContact: {
                    company: this.project.contact_company,
                    firstname: this.project.contact_firstname,
                    lastname: this.project.contact_lastname,
                    mobile: this.project.contact_mobile,
                    email: this.project.contact_email
                }
            })
        };
    },
    methods: {
        cancel() {
            this.$emit("closeModal");
        },
        updateContact() {
            this.form.post(this.route("advisors.projects.update", { project: this.project.uuid }), {
                preserveScroll: true,
                onSuccess: () => this.$notify({
                    group: "success",
                    title: 'actions.success',
                    text: 'projects.updated'
                })
            });
        }
    }
});
</script>

<style scoped></style>
